import { useState } from 'react';

export function CreateListingModal({ 
  isOpen, 
  onClose, 
  ownedTokens, 
  onCreateListing 
}) {
  const [selectedOwnership, setSelectedOwnership] = useState(null);
  const [listingAmount, setListingAmount] = useState(1);
  const [listingPrice, setListingPrice] = useState('');

  if (!isOpen) return null;

  const handleCreate = () => {
    onCreateListing({
      track_id: selectedOwnership.track_id,
      tokens_amount: listingAmount,
      price_per_token: parseFloat(listingPrice)
    });
  };

  const handleClose = () => {
    setSelectedOwnership(null);
    setListingAmount(1);
    setListingPrice('');
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-4">
      <div className="glass-card p-6 w-full max-w-md" data-testid="create-listing-modal">
        <h2 className="text-xl font-bold mb-4">List Tokens for Sale</h2>
        
        <div className="space-y-4">
          <div>
            <label className="block text-sm text-gray-400 mb-2">Select Track</label>
            <div className="space-y-2 max-h-48 overflow-y-auto">
              {ownedTokens.map(token => (
                <button
                  key={token.track_id}
                  onClick={() => {
                    setSelectedOwnership(token);
                    setListingAmount(Math.min(listingAmount, token.tokens_owned));
                  }}
                  className={`w-full p-3 rounded-lg text-left flex items-center gap-3 transition-all ${
                    selectedOwnership?.track_id === token.track_id 
                      ? 'bg-purple-500/20 border border-purple-500' 
                      : 'bg-white/5 hover:bg-white/10'
                  }`}
                >
                  <img 
                    src={token.track?.cover_url} 
                    alt={token.track?.title}
                    className="w-10 h-10 rounded object-cover"
                  />
                  <div className="flex-1">
                    <p className="font-medium">{token.track?.title}</p>
                    <p className="text-sm text-gray-400">Own: {token.tokens_owned}%</p>
                  </div>
                </button>
              ))}
            </div>
          </div>

          {selectedOwnership && (
            <>
              <div>
                <label className="block text-sm text-gray-400 mb-2">
                  Amount to Sell (max {selectedOwnership.tokens_owned}%)
                </label>
                <input
                  type="number"
                  min="1"
                  max={selectedOwnership.tokens_owned}
                  value={listingAmount}
                  onChange={(e) => setListingAmount(Math.min(parseInt(e.target.value) || 1, selectedOwnership.tokens_owned))}
                  className="w-full p-3 rounded-lg bg-white/5 border border-white/10 focus:border-purple-500 outline-none"
                  data-testid="listing-amount-input"
                />
              </div>

              <div>
                <label className="block text-sm text-gray-400 mb-2">Price per Token ($)</label>
                <input
                  type="number"
                  min="0.01"
                  step="0.01"
                  value={listingPrice}
                  onChange={(e) => setListingPrice(e.target.value)}
                  placeholder="0.00"
                  className="w-full p-3 rounded-lg bg-white/5 border border-white/10 focus:border-purple-500 outline-none"
                  data-testid="listing-price-input"
                />
              </div>

              {listingPrice && (
                <div className="bg-white/5 rounded-lg p-3">
                  <p className="text-sm text-gray-400">Total Value</p>
                  <p className="text-xl font-bold text-green-400">
                    ${(listingAmount * parseFloat(listingPrice || 0)).toFixed(2)}
                  </p>
                  <p className="text-xs text-gray-500 mt-1">5% platform fee applies on sale</p>
                </div>
              )}
            </>
          )}
        </div>

        <div className="flex gap-3 mt-6">
          <button 
            onClick={handleClose}
            className="flex-1 py-3 rounded-lg bg-white/10 hover:bg-white/20"
          >
            Cancel
          </button>
          <button 
            onClick={handleCreate}
            disabled={!selectedOwnership || !listingPrice}
            className="flex-1 py-3 rounded-lg bg-gradient-to-r from-purple-500 to-pink-500 font-medium disabled:opacity-50"
            data-testid="confirm-listing"
          >
            Create Listing
          </button>
        </div>
      </div>
    </div>
  );
}
